import styled from "styled-components";

export const Container = styled.div`
	width: 300px;
	border-radius: 8px;

	h3 {
		border-radius: 8px;
		display: flex;
		align-items: center;
		gap: 2px;
		color: black;

		white-space: nowrap;
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 16px;
		font-weight: 600;
		max-width: 200px;

		transition: 200ms ease-out;

		border: solid 3px #3f3f3f;

		padding: 5px 10px;

		strong {
			font-weight: 700;
			font-size: 12px;
			color: gray;
		}

		.content {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 5px 15px;
		}
	}
`;
